import {useContext, useEffect, useState} from "react"
import {AppContext} from "../context/AppContext"
import {Form} from "react-bootstrap"
import ReactSelect from "react-select";
import Loading from "../sharedComponents/Loaders/Loading";
import {Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import ic_eyes from "../assets/images/ic_eyes.svg";
import {simpleGetCall, simpleGetCallWithErrorResponse, simplePostCall} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import {notifyError} from "../sharedComponents/notify";
import {Modal} from "react-bootstrap";


function InventoryLog() {


    const {sidebar} = useContext(AppContext)

    const [isLoading, setIsLoading] = useState(false)

    const [inventoryId, setInventoryId] = useState([])

    const [selectedSlot, setSelectedSlot] = useState('')

    const [inventoryLogData, setInventoryLogData] = useState([])

    const [vendingMachineList, setVendingMachineList] = useState([])

    const [selectedVendingMachine, setSelectedVendingMachine] = useState('')

    const [openLogData, setOpenLogData] = useState(false)

    const [logData, setLogData] = useState({})

    const getInventoryId = (event) => {
        console.log(event.target.value);
        setSelectedVendingMachine(event.target.value)
        simpleGetCallWithErrorResponse(ApiConfig.GET_SLOTS + event.target.value).then((res) => {
            if (!res.error) {
                setInventoryId(res.json.slice(0, 100))
            } else {
                console.log('something went wrong');
            }
        }).catch((err) => {
            console.log(err);
        })

    }

    const getAllVendingMachine = () => {
        simpleGetCall(ApiConfig.GET_ALL_VENDING_MACHINE).then((res) => {
            if (res.result) {
                setVendingMachineList(res.vendingMachineList)
            } else {
                console.log('something wen wrong');
            }
        }).catch((err) => {
            console.log(err);
        })
    }


    useEffect(() => {
        getAllVendingMachine()
    }, [])


    const getInventoryLogById = (e) => {
        setSelectedSlot(e.target.value)
        setIsLoading(true)
        simplePostCall(ApiConfig.GET_INVENTORY_LOG_BY_ID, JSON.stringify({
            machineId: Number(selectedVendingMachine), slotNo: e.target.value
        })).then((res) => {
            if (res.success) {
                console.log(res);
                setInventoryLogData(res.data)
                console.log(JSON.parse(res.data[0].json));
            } else {
                notifyError('somethig went')
            }
            setIsLoading(false)
        }).catch((err) => {
            console.log(err);
            notifyError('somethig went wrong try again')
            setIsLoading(false)
        })
    }


    return (<main
        id="cx-main"
        className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
        <div className="heading-btn-main">
            <div className="heading-common">
                <label htmlFor="">INVENTORY LOG</label>
            </div>
        </div>
        <div className="table-wrapper">
            <div className="select-wrapper row">
                <Form.Group className="mb-4 col-md-3">
                    <Form.Label>Select Vending Machine</Form.Label>
                    <Form.Select
                        value={selectedVendingMachine}
                        onChange={getInventoryId}
                    >
                        <option>Select Vending Machine</option>
                        {vendingMachineList.map((machine, index) => {
                            return <option key={machine.id} value={machine.id}>{machine.name}</option>
                        })}
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mb-4 col-md-3">
                    <Form.Label>SLOT ID</Form.Label>
                    <Form.Select aria-label="Default select example"
                                 value={selectedSlot}
                                 onChange={getInventoryLogById}>
                        <option>Select Slot ID</option>
                        {inventoryId.map((id, index) => {
                            return <option value={id.slotNo} key={index}>{id.slotNo}</option>
                        })}
                    </Form.Select>
                </Form.Group>
            </div>
            {isLoading ? (<Loading/>) : (<Table striped hover id="TransactionLog" class="table display">
                <thead>
                <tr>
                    <th>Transaction Date</th>
                    <th>Steps</th>
                    <th>Function Code</th>
                    <th>Log Data</th>
                    <th>View Log</th>
                </tr>
                </thead>

                <tbody>
                {inventoryLogData?.length > 0 ? (inventoryLogData.map((data, index) => {
                    return (<tr key={data.id}>
                        <td style={{width: "300px !important"}}>
                            {data?.createdAt}
                        </td>
                        <td>{data?.step}</td>
                        <td>{data?.funcode ? data?.funcode : "NULL"}</td>
                        <td className="">
                            <div
                                className="text-truncate m-0"
                                style={{maxWidth: "300px", cursor: "pointer"}}
                                data-bs-toggle="tooltip"
                                data-bs-placement="left"
                                title={data?.json}
                            >
                                {data?.json}
                            </div>
                        </td>
                        <td className="action">
                            <Link
                                to="#"
                                className="icon"
                                onClick={() => {
                                }}
                            >
                                <img src={ic_eyes} alt="" onClick={() => {

                                    setLogData(JSON.parse(data?.json))

                                    setOpenLogData(true)
                                }}/>
                            </Link>
                        </td>
                    </tr>);
                })) : (<p className="text-danger my-3">No Data Found</p>)}
                </tbody>
            </Table>)}
        </div>

        <Modal
            show={openLogData}
            onHide={() => setOpenLogData(false)}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>USER DETAILS</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">Capacity :</label>
                    </div>
                    <div className="col-3 ">
                        <span>{logData.Capacity}</span>
                    </div>
                </div>

                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">FunCode
                            :</label>
                    </div>
                    <div className="col-3 ">
                        <span>{logData.FunCode}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">MachineId:</label>
                    </div>
                    <div className="col-3 ">
                        <span>{logData?.MachineId}</span>
                    </div>
                </div>
                <div className="row user-detail">
                    <div className="col-3 ">
                        <label htmlFor="">Name :</label>
                    </div>
                    <div className="col-3 ">
                        <span>{logData?.Name}</span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </main>)

}

export default InventoryLog